import React from 'react';
import { getFormatedDate } from 'utils/Global';
import './commandPanelImageComponent.scss';
interface CommandPanelImagProps {
  image: any;

  inspectionName: any;
  imageName: any;
  inspectionDateTime: any;
  active: any;
  onClick: any;

  children?: any;
  disabled?: boolean;
}
function CommandPanelImage({
  image,

  inspectionName,
  imageName,
  inspectionDateTime,
  active,
  onClick,

  children,
  disabled,
}: CommandPanelImagProps) {
  return (
    <div id='commandpanelimagecomponents-wrapper'
      style={{
        width: '12vw',
        height: 'auto',
        borderColor: 'rgba(92, 92, 92, 1)',
        borderWidth: '1px',
        margin: '0.2vw',
        borderStyle: 'solid',
        backgroundColor: active ? '#85BAFF' : '#ffffff',
        color: '#000000',
        paddingBottom: '10px',
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
      onClick={!disabled ? onClick : undefined}
    >
      <div id='commandpanelimagecomponents-content' style={{ marginTop: '0.5vw' }}>
        <div id={`commandpanelimagecomponents-imagename-${imageName}`} className="focus-level-text"> {imageName}</div>
        <div id={`commandpanelimagecomponents-inspectiondatetime-${inspectionDateTime}`} className="focus-level-date-time">
          {' '}
          {getFormatedDate(inspectionDateTime)}
        </div>
        <div id={`commandpanelimagecomponents-inspectionname-${inspectionName}`} className="focus-level-date-time">{inspectionName}</div>
      </div>

      {image ? (
        <div id="commandpanelimagecomponents-image-wrapper"
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
          }}
        >
          <img id="commandpanelimagecomponents-image" src={image} style={{ width: '85%', borderRadius: 5 }} alt="No Image" />
        </div>
      ) : (
        <div id="commandpanelimagecomponents-noimage" className="flex flex-xy-center"> No Image</div>
      )}
      <div id="commandpanelimagecomponents-children-wrapper"
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
          alignContent: 'center',
          marginTop: '0.3vw',
        }}
      >
        {children}
      </div>
    </div>
  );
}
export default CommandPanelImage;
